import styled, { css } from "styled-components";
import { Isku } from "../../client/product/useProduct";
import { Heading6, Subtitle1 } from "../../components/Typography";
import { COLOR_WHITE, COLOR_YELLOW } from "../../constants/colors";

type OptionProps = {
  selected: boolean;
  selectedSize: string;
  isAvailable: boolean;
};

type Props = {
  skus: Isku[];
  selectedOption: Isku | undefined;
  setSelectedOption: (sku: Isku) => void;
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  ${Heading6}
  width: 100px;
  color: ${COLOR_WHITE};
  flex-shrink: 0;

  @media (max-width: 1140px) {
    width: 100px;
  }

  @media (max-width: 576px) {
    width: 65px;
  }
`;

const Options = styled.div`
  display: flex;
  column-gap: 12px;
  row-gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

const Option = styled.div<OptionProps>`
  ${Subtitle1}

  display: flex;
  color: ${COLOR_WHITE};
  cursor: pointer;
  padding: 8px 28px;
  border: 1px solid transparent;
  align-items: center;
  justify-content: center;
  border-radius: 100px;

  @media (max-width: 768px) {
    padding: 4px 16px;
  }

  ${(props) =>
    props.selected &&
    css`
      color: ${COLOR_YELLOW};
      border: 1px solid ${COLOR_YELLOW};
    `}

  ${(props) =>
    !props.isAvailable &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: auto;
    `}
`;

function OptionPicker(props: Props) {
  const { skus, selectedOption: selectedSize, setSelectedOption: setSelectedSize } = props;

  return (
    <Container>
      <Title>Option:&nbsp;</Title>
      <Options>
        {skus.map((sku) => (
          <Option
            selected={selectedSize?.option === sku.option}
            selectedSize={selectedSize?.option.toLowerCase() || "normal"}
            onClick={() => setSelectedSize(sku)}
            isAvailable={sku.quantity > 0}
          >
            {sku.option.toUpperCase()}
          </Option>
        ))}
      </Options>
    </Container>
  );
}

export default OptionPicker;
